export default class Platform {
  isWeiXin() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') > 0;
  }
}